import { render, staticRenderFns } from "./ModuleEditorHeader.vue?vue&type=template&id=1b1c0720&scoped=true"
import script from "./ModuleEditorHeader.vue?vue&type=script&lang=js"
export * from "./ModuleEditorHeader.vue?vue&type=script&lang=js"
import style0 from "./ModuleEditorHeader.vue?vue&type=style&index=0&id=1b1c0720&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1c0720",
  null
  
)

export default component.exports